import {
  DEFAULT_NOTIFICATION_TOAST_STATUS,
  NOTIFICATION_TOAST_ALIAS_MAP,
} from './notification-toast-constants';

export const getColorPattern = patternAlias =>
  NOTIFICATION_TOAST_ALIAS_MAP[patternAlias] ??
  DEFAULT_NOTIFICATION_TOAST_STATUS;
